<div class="flex flex-col h-full bg-white relative" *ngrxLet="viewModel$; let value">

  <div class="items-center" id="ccActionBar">
    <div class="scrollable">
      <app-cc-keywords-bar class="grow"></app-cc-keywords-bar>
      <app-cc-radius></app-cc-radius>
      <app-cc-gmb-location-grp></app-cc-gmb-location-grp>
    </div>

    <button mat-stroked-button
            class="min-w-fit ml-6"
            [disabled]="!canCreateGbpConnection(value.focusedLocation, value.ongoingActions)"
            (click)="locationListService.editGBPConnection(value.focusedLocation, 'create')"
            appGtagEvent
            trackOn="click"
            action="create GMB location"
            category="Single-location action [overhaul]"
            [params]="{event_label: 'Create a new GMB location for a BLS location'}">
      <mat-icon svgIcon="add_circle_outline" class="h-[24px] w-[24px] text-[24px] mb-[3px]"></mat-icon>
      New GBP location
    </button>

    <div class="p-0 h-[40px] min-w-[40px] mx-3 rounded-lg"
         id="ccRefreshButton"
         [class.highlighted]="value.focusedLocationId && !value.ccLocations.length ||
              value.ccListPossiblyOutOfDate"
         [ngClass]="{'disabled': !value.focusedLocationId}"
      (click)="refresh()"
      [matTooltip]="value.focusedLocationId ? 'Refresh CC results' : ''"
      appGtagEvent
      trackOn="click"
      action="Refresh CC results"
      category="Multi-location action [overhaul]">
      <div class="flex flex-col items-center justify-between">
        <div class="flex">
          @if (!(delayedLoading$ | ngrxPush)) {
            <mat-icon
            svgIcon="refresh"></mat-icon>
          } @else {
            <mat-spinner [diameter]="20" id="spinner"></mat-spinner>
          }
        </div>
      </div>
    </div>
  </div>

  <div id="ccListTableContainer"
       (mouseleave)="onGridMouseLeave(value.hoveredCcRowSetting, value.focusedLocationId)">
      <ag-grid-angular
          style="width: 100%; height: 100%"
          class="ag-theme-material"
          [defaultColDef]="defaultColumnDefs"
          [columnDefs]="columnDefs"
          [gridOptions]="gridOptions"
          [rowData]="value?.ccLocations"
          [loading]="delayedLoading$ | ngrxPush"
          (gridReady)="onGridReady($event)"
          (rowDataUpdated)="onRowDataUpdated($event)"
          (selectionChanged)="onSelectionChanged($event, value.ccRowSettingsDictionary, value.focusedLocationId)"
          (columnPinned)="onColumnPinned($event)"
          (columnMoved)="onColumnMoved($event)"
          (columnResized)="onColumnResized($event)"
          (sortChanged)="onSortChanged($event)"
          (filterChanged)="onFilterChanged($event)"
          (cellMouseOver)="onCellMouseOver($event, value.hoveredCcRowSetting, value.ccRowSettingsDictionary, value.focusedLocationId)"
          (cellMouseOut)="onCellMouseOut(value.hoveredCcRowSetting, value.focusedLocationId)"
      ></ag-grid-angular>
  </div>

  <div class="footer">
    @if (value.timestamp) {
      <span class="pl-[24px]">{{'Last refresh: ' + (value.timestamp | date:'EEEE, H:mm:ss') }}</span>
    }

    <div class="grow"></div>

    <span class="pr-2 text-label-medium">Continue after:</span>
    <mat-checkbox [checked]="value.continueAfterCreate" (change)="onContinueAfterCreateChange($event)">
      <span class="text-body-medium pr-1">Creating a GBP location</span>
    </mat-checkbox>
    <mat-checkbox [checked]="value.continueAfterClaim" (change)="onContinueAfterClaimChange($event)">
      <span class="text-body-medium">Claiming</span>
    </mat-checkbox>

    <mat-divider vertical class="mx-4"></mat-divider>

    <app-jumper [showSideArrows]="true"
                class="mr-4"
                [currentItemIndex]="value.focusedLocationIndex !== undefined ? value.focusedLocationIndex + 1 : 0"
                [numberOfItems]="value.focusedLocationIndex !== undefined ? value.total : 0"
                (currentItemChanged)="changeFocusedRow($event - 1)"></app-jumper>

  </div>


</div>
